
import _ from "underscore";
import templateUrl from 'servicestack/automations/automations-center.htm'
import AutoQuery from 'servicestack/auto-query/auto-query'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import AutomationPrompt from "servicestack/automations/automation-prompt";
import ServiceBus from "servicestack/service-bus";
import 'servicestack/automations/automations-center.client.scss';

class AutomationsCenterController {
    constructor($rootScope) { 
        let $ctrl = this;
        basicController($ctrl);
		$ctrl.bus = new ServiceBus();
    }
	$onInit() {
		const $ctrl = this;
	}
}

let AutomationsCenter = {
    bindings: {
    },
    controller: AutomationsCenterController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}

export default AutomationsCenter